import React, {useState, useEffect, useCallback} from "react";

import { TranslationService } from "../../services";

const Context = React.createContext({
  subscriptionsTranslations: null,
  translate: (key) => key,
});

//TODO: EVENTUALLY DELETE THIS AND MODIFY COMMON TRANSLATIONS TO INCLUDE ALL BUNDLES
export function SubscriptionsTranslationsProvider({ locale, children }) {
  const [subscriptionsTranslations, setSubscriptionsTranslations] = useState(null);

  useEffect(() => {
    TranslationService.getBundle("subscriptions", locale)
      .then((data) => {
        setSubscriptionsTranslations(data);
      })
      .catch((e) => {
        console.error("Failed to load subscriptions translations." , e);
      });
  }, [locale]);

  const translate = useCallback(
      (key) => subscriptionsTranslations?.[key] || key,
      [subscriptionsTranslations]
  );

  return (
    <Context.Provider value={{ subscriptionsTranslations, translate }}>
      {children}
    </Context.Provider>
  );
}

//TODO: Consumers are for legacy code, remove when there are no class components using this
export const SubscriptionsTranslationsConsumer = Context.Consumer;
export const SubscriptionsTranslationsContext = Context;